module.exports = __webpack_public_path__ + "img/CN.eea0e476.svg";